export const getScrFromIframe = (iframe) => {
  if (iframe) {
    let src = iframe.replace(/\n/g, "");
    const regex = /<iframe.*?src='(.*?)'/;
    if (regex.exec(src)) return regex.exec(src)[1];
  }
  return "";
};